export const coreValues = [
  {
    title: 'Champions',
    description: `Whether it's new technologies, best practices or the social conscience of the 
    industry, we're always striving to be a force for progress.`
  },
  {
    title: 'People',
    description: `We put people at the center of everything we do. A collaborative mentality makes 
    our whole much greater than the sum of our parts.`
  },
  {
    title: 'Passion',
    description: `Disruptive thinking and innovation is a part of who we are, and there's no place 
    we'd rather be than in the trenches bringing the future of sales to life.`
  },
  {
    title: 'Purpose',
    description: `Being co founded by Entrepreneurs, our work goes beyond the boundaries of an 
    ordinary job and permeates throughout our team, our culture, and our work.`
  },
  {
    title: 'Learning',
    description: `We are proud and life-long, continuous learners dedicated to bettering ourselves 
    and becoming thought leaders to help those around us achieve their dreams.`
  }
]
